import styled from 'styled-components';

export default styled.div`
  && {
    background-color: rgba(193, 225, 141, 1);
    padding: 0 40px 25px 40px;
    .ant-input {
      word-spacing: -2px;
    }
    .ant-btn-primary:hover,
    .ant-btn-primary:focus {
      color: #ff8a00;
      background: white;
      border: 1px solid #ff8a00;
    }
    .detail {
      background-color: white;
      border-radius: 10px;
      padding: 15px;
      .column {
        .ant-form-item {
          width: 100%;
          padding-right: 10px;
          margin-bottom: 10px;
          .input {
            width: 100%;
          }
        }
        .label-installation-date {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }
        .dflex {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 10px;
          .mr-b-10 {
            margin-bottom: 10px;
          }
          .ant-form-item {
            width: unset;
            padding-right: unset;
            margin-bottom: 10px;
          }
        }
      }
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        .ant-form-item-control-input-content {
          display: flex;
          justify-content: center;
        }
        .btnDefault {
          border: 1px solid #ff8a00;
        }
      }
      .btnSearch {
        height: 34px;
      }
      .backSetup {
        margin-right: 10px;
        width: 80px;
        height: 34px;
        background-color: #c4c4c4;
        color: white;
        border-radius: 5px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
        border-style: none;
      }
    }
    @media screen and (max-width: 844px) {
      height: auto;
      padding: 0 20px 25px 20px;
      .detail {
        display: block;
        padding: 15px 10px 10px;
        .search,
        .search + .ant-col {
          flex: none;
          max-width: 100%;
        }
        .ant-input {
          font-size: 16px;
        }
        .search .label-search {
          width: 30%;
          height: 22px;
        }
        .ant-form-item {
          margin-bottom: 5px;
        }
        .btn .ant-form-item-control-input-content {
          justify-content: center;
          padding-top: 10px;
        }
      }
    }
  }
`;
